import React, { forwardRef } from 'react';

import styled from '@emotion/styled';

import CalendarIcon from '../../../../components/Icons/CalenderIcon';
import { Modal } from '../../../../components/Modals/Modal';
import CalenderModal from '../../../../components/Modals/ModalsActions/CalenderModal';
import ModalTriggerContainer from '../../../../components/Modals/ModalTriggerContainer';
import { ModalProvider } from '../../../../context/ModalContext';

const ApplicantCalendarModal = forwardRef<
  HTMLDivElement,
  { applicantId: string }
>(({ applicantId }, ref) => {
  return (
    <ModalProvider>
      <ModalTriggerContainer ref={ref}>
        <IconWrapper>
          <CalendarIcon />
        </IconWrapper>
      </ModalTriggerContainer>
      <Modal>
        <CalenderModal applicantId={applicantId} />
      </Modal>
    </ModalProvider>
  );
});

export default ApplicantCalendarModal;

const IconWrapper = styled.div`
  cursor: pointer;
`;
